export const TrackingKeys = {
    BREADCRUMBS_HOME: 'breadcrumbs-home',
    BURGER_MENU: 'menu-burger',
    HEADER_LOGO: 'header-logo-link',
    PRODUCT_DETAILS_TOGGLE: 'product-details-toggle',
} as const;
